// extracted by mini-css-extract-plugin
export default {"background":"AccessDenied_background__6cr2a"};